<template>
  <PageWithImage
    :high-res-img-src="landingPageHighRes"
    :low-res-img-src="landingPageLowRes"
  >
    <NarrowPage>
      <template #logo>
        <CarvisLogo class="w-full text-blue" />
      </template>
      <template #title>
        Grüß Gott!
      </template>
      <CarvisText class="mb-4">
        <span class="text-blue font-semibold">Carvis</span> ist ein exklusives Netzwerk für Porsche-Händler. Wir helfen Dir dabei, Deine Fahrzeuge einem Netzwerk von anderen Porsche-Händlern zu präsentieren.
        Im Gegenzug bist Du in der Lage, Fahrzeuge anderer Händler anzuschauen.
      </CarvisText>
      <CarvisText>
        Bitte beachte, dass es sich bei <span class="text-blue font-semibold">Carvis</span> um ein exklusives Netzwerk handelt, weshalb nur ausgewählte Händler im Netzwerk zugelassen werden.
        Du darfst Dir gerne ein Konto erstellen, allerdings muss dieses von einem Administrator freigeschalten werden, bevor Du es benutzen kannst.
      </CarvisText>
      <div class="flex space-x-4 mt-6">
        <CarvisButton
          block
          color="primary"
          to="/login"
          @click="$router.push('/login')"
        >
          Zum Login
        </CarvisButton>
        <CarvisButton
          block
          @click="$router.push('/signup')"
        >
          Konto erstellen
        </CarvisButton>
      </div>
    </NarrowPage>
  </PageWithImage>
</template>

<script setup lang="ts">
import landingPageHighRes from '@/assets/landing_page_highres.webp'
import landingPageLowRes from '@/assets/landing_page_lowres.webp'
import CarvisLogo from '@/components/navigation/CarvisLogo.vue'
import NarrowPage from '@/components/pages/NarrowPage.vue'
import PageWithImage from '@/components/pages/PageWithImage.vue'
</script>
